import { TablePagination, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { CSSProperties } from "@material-ui/styles";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { FormChange } from "@saleor/hooks/useForm";
import { usePaginate } from "@saleor/hooks/usePaginate";
import {
  // maybe,
  renderCollection
  // transformOrderStatus,
  // transformPaymentStatus
} from "@saleor/misc";
import classNames from "classnames";
import _ from "lodash";
import moment from "moment-timezone";
import * as React from "react";
import { FormattedMessage } from "react-intl";

import { Order } from "../BatchAssignmentListHead";
interface BatchAssignmentListProps {
  data: {
    riderId: string;
    riderName: string;
    order_code: string;
    orders: Order[];
  };
  change: FormChange;
  onDelete: (id: string) => void;
}

const useStyles = makeStyles(
  theme => {
    const dataDisplay: CSSProperties = {
      flex: "60%",
      overflow: "auto",
      textAlign: "left"
    };

    return {
      dataTitle: {
        display: "none !important"
      },
      dispatchTbl: {
        [theme.breakpoints.down("md")]: {
          "& thead": {
            display: "none !important"
          },
          "& thead, tbody, th, td, tr": {
            border: "none",
            display: "block"
          },
          "& tr": {
            backgroundColor: "#fff !important",
            borderBottom: "1px solid #ccc",
            paddingBottom: "30px",
            paddingTop: "30px"
          }
        },
        tableLayout: "auto",
        width: "100%"
      },
      [theme.breakpoints.down("md")]: {
        dataDisplay,
        dataGroup: {
          display: "flex"
        },
        dataTitle: {
          display: "block !important",
          flex: "40%",
          fontWeight: "bold",
          textAlign: "left"
        }
      },
      responsiveTable: {
        overflow: "auto !important"
      },
      tableRow: {
        cursor: "pointer" as "pointer"
      },
      tableRowError: {
        // border: "2px solid #EC5D77"
        background: "#ec5d7740"
      },
      tblCol: {
        fontSize: "1.3em",
        fontWeight: 600 as 600,
        whiteSpace: "nowrap",
        width: "auto"
      }
    };
  },
  { name: "BatchAssignmentList" }
);

const BatchAssignmentList: React.FC<BatchAssignmentListProps> = props => {
  const { data, onDelete } = props;
  const classes = useStyles(props);
  const [pageInfo, setPageInfo] = React.useState({
    currentPage: 0,
    pageSize: 30
  });

  const { pageChange, paginate, changeRow } = usePaginate();

  const orders = paginate(data.orders, pageInfo.currentPage, pageInfo.pageSize);

  return (
    <div className={classes.responsiveTable}>
      <Table className={classes.dispatchTbl}>
        <TableHead>
          <TableRow>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Order Number" />
            </TableCellHeader>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Customer Name" />
            </TableCellHeader>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Address" />
            </TableCellHeader>
            <TableCellHeader className={classes.tblCol}>
              <FormattedMessage defaultMessage="Target Delivery Date" />
            </TableCellHeader>
            <TableCellHeader className={classes.tblCol}></TableCellHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {renderCollection(
            orders,
            order => (
              <TableRow
                key={order.id}
                className={classNames(null, {
                  [classes.tableRowError]: !order.isValid
                })}
              >
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Order Number</div>
                    <div className={classes.dataDisplay}>{order.orderCode}</div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Customer Name</div>
                    <div className={classes.dataDisplay}>
                      {order?.user?.firstName} {order?.user?.lastName}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>Address</div>
                    <div className={classes.dataDisplay}>
                      {order?.shippingAddress?.streetAddress1}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}>
                      Target Delivery Date
                    </div>
                    <div className={classes.dataDisplay}>
                      {moment(order.shippingSchedule).format("LL")}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className={classes.dataGroup}>
                    <div className={classes.dataTitle}></div>
                    <div className={classes.dataDisplay}>
                      <IconButton
                        color="default"
                        component="span"
                        onClick={() => onDelete(order.id)}
                      >
                        <HighlightOffIcon color="error" />
                      </IconButton>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={5} padding="default">
                  <Typography variant="h5" align="center">
                    No Data
                  </Typography>
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 20, 30]}
        count={data?.orders?.length}
        page={pageInfo.currentPage}
        onChangePage={(_event: any, page: any) =>
          pageChange(page, pageInfo, setPageInfo)
        }
        onPageChange={(_event: any, page: any) =>
          pageChange(page, pageInfo, setPageInfo)
        }
        rowsPerPage={pageInfo.pageSize}
        onChangeRowsPerPage={event => changeRow(event, pageInfo, setPageInfo)}
        onRowsPerPageChange={event => changeRow(event, pageInfo, setPageInfo)}
      />
    </div>
  );
};

export default BatchAssignmentList;
